import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, SkipSelf } from '@angular/core';
import { ControlContainer, ReactiveFormsModule } from '@angular/forms';
import { PaylineAccount } from '../../../banking/models/payline-account';
import { BehaviorSubject } from 'rxjs';
import { RadioButtonInputComponent } from '../../../../ui/form-components/radio-button-input/radio-button-input.component';
import { ReviewEntryComponent } from '../../../../ui/review-components/review-entry/review-entry.component';
import { AsyncPipe, DatePipe } from '@angular/common';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-payline-account-accordion-radio-card',
  templateUrl: './payline-account-accordion-radio-card.component.html',
  styleUrls: ['./payline-account-accordion-radio-card.component.scss'],
  standalone: true,
  viewProviders: [
    {
      provide: ControlContainer,
      useFactory: (container: ControlContainer) => container,
      deps: [[new SkipSelf(), ControlContainer]]
    }
  ],
  imports: [
    RadioButtonInputComponent,
    ReviewEntryComponent,
    DatePipe,
    AsyncPipe,
    NgbAccordionModule,
    ReactiveFormsModule
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaylineAccountAccordionRadioCardComponent {
  @Input() paylineAccount!: PaylineAccount;
  @Output() selected = new EventEmitter<void>();

  private _accordionIsExpanded = new BehaviorSubject<boolean>(false);
  public accordionIsExpanded$ = this._accordionIsExpanded.asObservable();

  public generatedRandomId = `account-${Math.random().toString(36).slice(2)}`;

  public toggleAccordionExpand(): void {
    this.accordionIsExpanded$.once(expanded => {
      this._accordionIsExpanded.next(!expanded);
    });
  }
}
